// SeriesZone — French. Two words are deliberately NOT repeated here because MarketPage (the
// only page that mounts this zone) already registers them with the same value: 'All' and
// 'nothing has answered yet'. Series labels and dimension tokens are NOT here either — they
// render through `seriesLabel`/`dimLabel` in `series.v1.ts`, like raster labels.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Series': 'Séries',
  'Public statistics about the market, not about one organisation — the file, the row and the date behind every figure':
    'Statistiques publiques sur le marché, non sur une organisation — le fichier, la ligne et la date derrière chaque chiffre',

  // the presets
  'RI beneficiaries': 'Bénéficiaires du RI',
  'Non-take-up': 'Non-recours',
  'Childcare': "Accueil de jour des enfants",
  'Child protection': "Protection de l'enfance",

  // the filter band
  'Source': 'Source',
  'Also from': 'Aussi depuis',

  // the grid
  'canton': 'canton',
  'Dimension': 'Dimension',
  'Geography': 'Géographie',
  'Show the file this figure was read from': 'Affiche le fichier dont provient ce chiffre',
  'was {value} in the file of {date}': 'valait {value} dans le fichier du {date}',

  // the empty and error states
  'The series store did not answer: {error}': "Le magasin des séries n'a pas répondu : {error}",
  'No point has landed for this series yet — the parser that fills it has not run, or has found nothing to file.':
    "Aucun point n'est encore arrivé pour cette série — le parseur qui la remplit n'a pas encore tourné, ou n'a rien trouvé à déposer.",
  'No series behind this preset has been built yet — a later wave of the sources programme fills it.':
    "Aucune série derrière cette présélection n'est encore construite — une vague ultérieure du programme des sources la remplira.",
  'Pick a series to read its figures.': 'Choisir une série pour lire ses chiffres.',
}, 'SeriesZone');
